export default __webpack_public_path__ + "static/pillar-3-1f5ec206542df1d1c81fd1699700469f.jpg";